import React, { useState } from "react";
import PropTypes from "prop-types";

// Placeholder UI for MessagingHub
function MessagingHub({ linkedInMessages, instagramMessages, onReply, loading, error }) {
  const [selectedPlatform, setSelectedPlatform] = useState("linkedin");
  const [replyText, setReplyText] = useState("");
  const [selectedThread, setSelectedThread] = useState(null);

  const messages = selectedPlatform === "linkedin" ? linkedInMessages : instagramMessages;

  const handleSelectThread = (thread) => {
    setSelectedThread(thread);
    setReplyText("");
  };

  const handleSendReply = () => {
    if (selectedThread && replyText.trim()) {
      onReply(selectedPlatform, selectedThread.id, replyText);
      setReplyText("");
    }
  };

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <div style={{ width: 220, borderRight: "1px solid #eee", padding: 16 }}>
        <button onClick={() => setSelectedPlatform("linkedin")}>LinkedIn</button>
        <button onClick={() => setSelectedPlatform("instagram")}>Instagram</button>
        <div style={{ marginTop: 16 }}>
          {loading ? (
            <div>Loading...</div>
          ) : error ? (
            <div style={{ color: "red" }}>{error}</div>
          ) : (
            messages.map((thread) => (
              <div
                key={thread.id}
                style={{
                  padding: 8,
                  background:
                    selectedThread && selectedThread.id === thread.id ? "#f0f0f0" : "#fff",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee",
                }}
                onClick={() => handleSelectThread(thread)}
              >
                <div>
                  <b>{thread.participant}</b>
                </div>
                <div style={{ fontSize: 12, color: "#888" }}>{thread.lastMessageSnippet}</div>
              </div>
            ))
          )}
        </div>
      </div>
      <div style={{ flex: 1, padding: 16, display: "flex", flexDirection: "column" }}>
        {selectedThread ? (
          <>
            <div style={{ flex: 1, overflowY: "auto", marginBottom: 16 }}>
              {selectedThread.messages.map((msg, idx) => (
                <div key={idx} style={{ marginBottom: 8 }}>
                  <b>{msg.sender}:</b> {msg.text}
                </div>
              ))}
            </div>
            <div style={{ display: "flex" }}>
              <input
                type="text"
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                placeholder="Type your reply..."
                style={{ flex: 1, marginRight: 8 }}
              />
              <button onClick={handleSendReply} disabled={!replyText.trim()}>
                Send
              </button>
            </div>
          </>
        ) : (
          <div style={{ color: "#888" }}>Select a conversation to view messages</div>
        )}
      </div>
    </div>
  );
}

MessagingHub.propTypes = {
  linkedInMessages: PropTypes.array.isRequired,
  instagramMessages: PropTypes.array.isRequired,
  onReply: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

MessagingHub.defaultProps = {
  linkedInMessages: [],
  instagramMessages: [],
  loading: false,
  error: null,
};

export default MessagingHub;
